import { Task } from 'taskarian';
import LearningCollectionEditStore from '..';
import { deleteToApi } from '../../../../../../Appy';
import { Link } from '../../../../../../Resource/Types';
import { LearningCollectionError } from '../../../Types';
import { DeletingSection } from '../Types';

export function deleteSection(store: LearningCollectionEditStore, state: DeletingSection) {
  Task.succeed<LearningCollectionError, Link>(state.deleteSectionLink)
    .andThen(deleteToApi)
    .fork(store.building, store.buildingWithoutSection);
}
